/*
 * uniso-data
 * http://www.uniso.lv
 * Version: 0.0.4 - 2016-08-26
 * License: MIT
 */
;(() => {
  angular.module("uniso-data", [])
}).call(this)

;(() => {
  angular
    .module("uniso-data")
    .service(
      "UnisoMetadata",
      () =>
        function (data) {
          this.columnOrder = []
          angular.forEach(data, (el) => {
            this[el.name] = el
            if (el.visible && el.name !== "id" && !el.name.endsWith("_hidden")) {
              return this.columnOrder.push(el.name)
            }
          })
          return this
        }
    )
    .provider("uuiDataConfig", () => {
      var cfg
      cfg = {
        dataPath: "./data/",
        countPath: "./data/count/",
      }
      cfg.$get = () => cfg
      return cfg
    })
    .service("uuiData", [
      "$rootScope",
      "$http",
      "$q",
      "$resource",
      "UnisoMetadata",
      "uuiDataConfig",
      function uuiData($rootScope, $http, $q, $resource, UnisoMetadata, uuiDataConfig) {
        var processData, srvc
        processData = (data, result, def, R) => {
          angular.forEach(data, (r) => result.push(new R(r)))
          result.$resolved = true
          return def.resolve(result)
        }
        srvc = {
          $cache: {},
          $api: [],

          metadata: function (code) {
            if (this.$cache[code]) {
              return $q.resolve(this.$cache[code])
            }
            return $http.get(`/metadata/${code}`).then((m) => {
              const md = new UnisoMetadata(m.data.fields)
              this.$cache[code] = md
              return md
            })
          },

          list: (code, params, succ, err, shouldConfirm) => {
            var R, def, result, url
            if (angular.isFunction(params)) {
              err = succ
              succ = params
              params = {}
            }
            result = []
            result.shouldConfirm = true
            if (shouldConfirm === false) {
              result.shouldConfirm = false
            }
            url = uuiDataConfig.dataPath + code
            def = $q.defer()
            result.$promise = def.promise.then(succ, err)
            result.$cancelRequest = () => true
            R = $resource(url)
            $http
              .get(url, {
                params: params,
              })
              .then(
                (resp) => {
                  var data
                  data = resp.data
                  return processData(data, result, def, R)
                },
                (err) => {
                  if (
                    err.status === 500 &&
                    err.data === "Pieprasījums atcelts, jo neiekļāvās tam paredzētajā laikā"
                  ) {
                    result.$resolved = true
                    return def.reject("Pieprasījums atcelts, jo neiekļāvās tam paredzētajā laikā")
                  } else {
                    result.$resolved = true
                    return def.reject(err)
                  }
                }
              )
            return result
          },
          record: (code, id, params, succ, err) => {
            if (angular.isFunction(params)) {
              err = succ
              succ = params
              params = {}
            }
            return $resource(`${uuiDataConfig.dataPath + code}/:id`).get(
              angular.extend(
                {
                  id: id,
                },
                params
              ),
              succ,
              err
            )
          },
          taPromise: (code, params) => $resource(uuiDataConfig.dataPath + code).query(params).$promise,
          clear: function () {
            this.$cache = {}
            this.$api = {}
          },
        }

        $rootScope.$on("cacheClear", () => {
          srvc.$cache = {}
          srvc.$api = {}
        })

        return srvc
      },
    ])
}).call(this)

;(() => {
  angular
    .module("uniso-data")
    .filter("filterDia", () => (input, viewValue, attr) => {
      var diacriticize, diacriticsMap, escapeRegexp, r, ret
      diacriticize = (query) => {
        var i
        i = 0
        while (i < diacriticsMap.length) {
          query = query.replace(new RegExp(diacriticsMap[i], "g"), diacriticsMap[i])
          i++
        }
        return query
      }
      escapeRegexp = (queryToEscape) => {
        if (!queryToEscape) {
          return ""
        }
        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1")
      }
      if (!viewValue) {
        return input
      }
      attr = attr || "nosaukums"
      diacriticsMap = [
        "[AĀ]",
        "[CČ]",
        "[EĒ]",
        "[GĢ]",
        "[IĪ]",
        "[KĶ]",
        "[LĻ]",
        "[NŅ]",
        "[SŠ]",
        "[UŪ]",
        "[ZŽ]",
        "[aā]",
        "[cč]",
        "[eē]",
        "[gģ]",
        "[iī]",
        "[kķ]",
        "[lļ]",
        "[nņ]",
        "[sš]",
        "[uū]",
        "[zž]",
      ]
      r = new RegExp(diacriticize(escapeRegexp(viewValue)), "i")
      ret = []
      angular.forEach(input, (row) => {
        if (r.test(row[attr])) {
          ret.push(row)
        }
      })
      return ret
    })
    .filter("stripHtml", () => (input) => {
      if (input) {
        return String(input.replace(/<[^>]*>/gm, ""))
      } else {
        return ""
      }
    })
    .filter("formatDate", [
      "$filter",
      ($filter) => (input) => {
        var v
        if (!input) {
          return
        }
        v = $filter("date")(input.replace(" ", "T"), "dd.MM.yyyy")
        if (v === "01.01.3000") {
          return null
        } else {
          return v
        }
      },
    ])
    .filter("formatDateTime", [
      "$filter",
      ($filter) => (input) => {
        var t
        if (!input) {
          return
        }
        t = $filter("date")(input.replace(" ", "T"), "dd.MM.yyyy HH:mm")
        if (t.indexOf("00:00") !== -1) {
          t = t.slice(0, 10)
        }
        return t
      },
    ])
    .filter("formatTime", [
      "$filter",
      ($filter) => (input) => {
        if (!input) {
          return
        }
        return $filter("date")(input.replace(" ", "T"), "HH:mm")
      },
    ])
    .filter("formatBool", () => (input) => {
      var C_YES_NO
      C_YES_NO = []
      C_YES_NO[true] = "Jā"
      C_YES_NO[false] = "Nē"
      return C_YES_NO[input]
    })
    .filter("moment", () => (input, format) => {
      if (input) {
        return moment(input.format(format ? format : "DD.MM.YYYY HH:mm"))
      }
    })
}).call(this)
